import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Layout, Icon } from 'antd';

export const SideMenu = styled(Layout.Sider)`
  border-right: 1px solid ${props => props.theme.color.siderBorder};
`;

export const SideMenuToggle = styled.div`
  padding: 0.5em 0;
  color: ${props => props.theme.color.sider};
  font-size: ${props => props.theme.fontSize.menuIcon};
  text-align: center;
  cursor: pointer;
`;

export const EllipsisLink = styled(Link)`
  overflow: hidden;
  text-overflow: ellipsis;
  width: fit-content;
`;

export const ResetIcon = styled(Icon)`
  color: ${props => props.theme.color.materialred500} !important;
`;

export const ResetText = styled.span`
  color: ${props => props.theme.color.materialred500} !important;
`;
